import { useMemo } from 'react';
import { shallow } from 'zustand/shallow';
import useBoundStore from 'store';

export type ApartmentFiltersSecondary = {
  buildingIds: number[];
  marketType?: string;
  priceFrom: number | undefined;
  priceTo: number | undefined;
  pricePerSqMTo: number | undefined;
  pricePerSqMFrom: number | undefined;
  secondaryMarketPriceDifferenceTo: number | undefined;
  secondaryMarketPriceDifferenceFrom: number | undefined;
  facilityTypeIds: number[];
  areaFrom: number | undefined;
  areaTo: number | undefined;
};

const useFilterQuerySecondary = (): ApartmentFiltersSecondary => {
  const storeParams = useBoundStore(
    ({
      selectedHouseIdsSecondary,
      priceRangeMin,
      priceRangeMax,
      priceRangePerSqmMin,
      priceRangePerSqmMax,
      secondaryDifferenceWithMarketPriceMin,
      secondaryDifferenceWithMarketPriceMax,
      selectedApartmentRoomSecondary,
      selectedApartmentRoomTypes,
      areaSqFootageRangeMin,
      areaSqFootageRangeMax,
      selectedPolygonSecondary,
    }) => ({
      selectedHouseIdsSecondary,
      priceRangeMin,
      priceRangeMax,
      priceRangePerSqmMin,
      priceRangePerSqmMax,
      secondaryDifferenceWithMarketPriceMin,
      secondaryDifferenceWithMarketPriceMax,
      selectedApartmentRoomSecondary,
      selectedApartmentRoomTypes,
      areaSqFootageRangeMin,
      areaSqFootageRangeMax,
      selectedPolygonSecondary,
    }),
    shallow,
  );

  const filter = useMemo(() => {
    const {
      selectedHouseIdsSecondary,
      priceRangeMin,
      priceRangeMax,
      priceRangePerSqmMin,
      priceRangePerSqmMax,
      secondaryDifferenceWithMarketPriceMin,
      secondaryDifferenceWithMarketPriceMax,
      selectedApartmentRoomTypes,
      areaSqFootageRangeMin,
      areaSqFootageRangeMax,
      selectedPolygonSecondary,
    } = storeParams;

    return {
      buildingIds: [...selectedHouseIdsSecondary.values()],
      priceFrom: priceRangeMin,
      priceTo: priceRangeMax,
      pricePerSqMTo: priceRangePerSqmMax,
      pricePerSqMFrom: priceRangePerSqmMin,
      facilityTypeIds: [...selectedApartmentRoomTypes.values()],
      secondaryMarketPriceDifferenceTo: secondaryDifferenceWithMarketPriceMax,
      secondaryMarketPriceDifferenceFrom: secondaryDifferenceWithMarketPriceMin,
      areaFrom: areaSqFootageRangeMin,
      areaTo: areaSqFootageRangeMax,
      buildingAddressSearchPoligons: selectedPolygonSecondary?.map((polygon) => polygon.coords),
    };
  }, [storeParams]);

  return filter;
};

export default useFilterQuerySecondary;
